import axios from "axios";
import { CONST } from "../config/const";

// 決済情報の登録なしのエントリー
export async function postEntryNoUsePayment(
  display: string,
  pathName: string,
  selectServiceNames: string[],
  customer_info: { [key: string]: string | string[] },
  inputID: string,
  serviceValues: number,
  serviceTaxs: number
) {
  try {
    const path = "entryNoUsePayment";
    const bodys = {
      display,
      pathName,
      selectServiceNames,
      customer_info,
      inputID,
      serviceValues,
      serviceTaxs,
    };
    const response = await axios.post(CONST.apiUrl + path, {
      bodys,
    });
    const result: string = response.data.add;
    const contract_number: string = response.data.contract_number;
    return { result, contract_number };
  } catch (error) {
    // logout();
    return { result: "", contract_number: "" };
  }
}

// 決済 - Jペイメント
export async function postEntryJPayment(
  display: string,
  pathName: string,
  selectServiceNames: string[],
  customer_info: { [key: string]: string | string[] },
  inputID: string,
  serviceValues: number,
  serviceTaxs: number
) {
  try {
    const path = "entryJPayment";
    const bodys = {
      display,
      pathName,
      selectServiceNames,
      customer_info,
      inputID,
      serviceValues,
      serviceTaxs,
    };
    const response = await axios.post(CONST.apiUrl + path, {
      bodys,
    });
    const result: string = response.data.add;
    const contract_number: string = response.data.contract_number;
    return { result, contract_number };
  } catch (error) {
    // logout();
    return { result: "", contract_number: "" };
  }
}

// 決済 - SBペイメント
export async function postEntrySBPayment(
  display: string,
  pathName: string,
  selectServiceNames: string[],
  customer_info: { [key: string]: string | string[] },
  inputID: string,
  serviceValues: number,
  serviceTaxs: number
) {
  try {
    const path = "entrySBPayment";
    const bodys = {
      display,
      pathName,
      selectServiceNames,
      customer_info,
      inputID,
      serviceValues,
      serviceTaxs,
    };
    const response = await axios.post(CONST.apiUrl + path, {
      bodys,
    });
    const result: string = response.data.add;
    const contract_number: string = response.data.contract_number;
    return { result, contract_number };
  } catch (error) {
    // logout();
    return { result: "", contract_number: "" };
  }
}
